import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFullName } from '@/utils';
import { useGetChildQuery } from '@/services/child-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import EditForm from './edit-form';

const ChildEditPage = () => {
  const navigate = useNavigate();
  const { childId } = useParams();
  const { data, isLoading } = useGetChildQuery({ childId }, { skip: !childId });

  useEffect(() => {
    if (childId && !isLoading && !data) {
      navigate('/child');
    }
  }, [childId, data, isLoading, navigate]);

  const title = childId ? 'Edit' : 'New';

  return (
    <Page
      breadcrumb={[
        { path: '/child', label: 'Children' },
        data && { path: `/child/${childId}`, label: getFullName(data.name) },
        title,
      ]}
      size="xl"
      loading={childId && !data}
    >
      <PageTitle label={`${title} Child`} />
      <EditForm childData={data} />
    </Page>
  );
};

export default ChildEditPage;
